import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { ModalActions } from 'components/modals/useModal';
import { FormattedMessage } from 'react-intl';
import { AffiliationForm } from 'types/employees';
import AffiliationModal from './AffiliationModal';

interface Props {
    readonly?: boolean;
    affiliation: AffiliationForm;
    onSave?: (data: AffiliationForm) => void;
    onDelete?: () => void;
    modalActions: ModalActions;
}

const AffiliationUnit = ({ affiliation, readonly, onSave, onDelete, modalActions }: Props) => {
    const openAffiliationModal = () =>
        modalActions.openModal(
            <AffiliationModal
                onClose={modalActions.closeModal}
                onDelete={onDelete}
                onSave={onSave}
                initialData={affiliation}
                titleId={'employees.affiliations.form.edit'}
            />
        );

    const getAffiliationView = (affiliation: AffiliationForm) => {
        return (
            <div className="flex flex-col">
                <strong>{affiliation.party?.name || 'No contact selected'}</strong>
                {affiliation.notes && <span className="text-fg-secondary">{affiliation.notes}</span>}
            </div>
        );
    };

    return (
        <div className="border-divider mb-2.5 flex items-center justify-between border-b pr-2.5 pb-2.5">
            {getAffiliationView(affiliation)}
            {readonly ? (
                <div />
            ) : (
                <Button {...buttonStyle({ variant: 'outlined', size: 'extraSmall' })} onClick={openAffiliationModal}>
                    <FormattedMessage id="edit" />
                </Button>
            )}
        </div>
    );
};

export default AffiliationUnit;
